import { useEffect, useMemo, useRef } from 'react';
import useSocket, { Options, ReadyState } from 'react-use-websocket';

import { transformIncomingData } from '../api/utils/dataTransform';
import { useAuth } from '../contexts/AuthContext';

interface UseWebSocketHook {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  lastJsonMessage: any;
  readyState: ReadyState;
}
interface Params {
  topic: string;
}

const BASE_URL = window.env?.ALERTS_WEBSOCKET_URL;

export const useWebSocket = (initialParams: Params, options?: Options): UseWebSocketHook => {
  const { userIdentity } = useAuth();
  const didUnmount = useRef(false);
  const params = useRef(initialParams);
  const { readyState, lastJsonMessage } = useSocket(BASE_URL, {
    shouldReconnect: () => {
      return didUnmount.current === false;
    },
    reconnectAttempts: 10,
    reconnectInterval: 3000,
    share: true,
    queryParams: {
      auth_email: userIdentity?.email ? encodeURIComponent(userIdentity.email) : '',
      auth_token: userIdentity?.token || '',
      auth_type: userIdentity?.type || '',
      ...params.current,
    },
    ...options,
  });

  useEffect(() => {
    return () => {
      didUnmount.current = true;
    };
  }, []);

  return { readyState, lastJsonMessage: useMemo(() => transformIncomingData(lastJsonMessage), [lastJsonMessage]) };
};
